<script>
import { BFormCheckbox, BFormGroup } from "bootstrap-vue-next";

export default {
  name: "SeatAssignmentMode",
  components: {
    BFormCheckbox,
    BFormGroup,
  },
  props: {
    modelValue: { type: Boolean, required: true },
  },
  emits: ["update:modelValue"],
};
</script>

<template>
  <BFormGroup label="Seat assignment mode:">
    <div class="d-flex align-items-center gap-2">
      <span :class="{ 'fw-bold': !modelValue }">Whole order</span>
      <BFormCheckbox
        :model-value="modelValue"
        switch
        class="mb-0"
        @update:model-value="$emit('update:modelValue', $event)"
      />
      <span :class="{ 'fw-bold': modelValue }">Split order</span>
    </div>
  </BFormGroup>
</template>
